(() => {
  if (window.smokeShockClicks) return;
  window.smokeShockClicks = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483647;';
  const context = canvas.getContext('2d');
  if (!context) return;
  document.body.appendChild(canvas);
  let particles = [];
  let frame = 0;
  let previous = 0;
  function resize() {
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = window.innerWidth * ratio;
    canvas.height = window.innerHeight * ratio;
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
  }
  function draw(time) {
    const delta = Math.min((time - previous) / 1000 || 0.016, 0.04);
    previous = time;
    context.clearRect(0, 0, window.innerWidth, window.innerHeight);
    particles = particles.filter(p => p.age < p.life);
    for (const p of particles) {
      p.age += delta;
      if (p.age < 0) continue;
      // A narrow fast jet slows down and billows as it travels.
      p.x += (p.vx + Math.sin(p.age * 9 + p.phase) * 18 * p.age) * delta;
      p.y += p.vy * delta;
      p.vx *= Math.exp(-1.1 * delta);
      p.vy *= Math.exp(-0.85 * delta);
      const progress = Math.min(p.age / p.life, 1);
      const radius = p.radius + Math.pow(progress, 1.2) * 38;
      const opacity = Math.min(p.age / 0.06, 1) * Math.pow(1 - progress, 1.3) * 0.42;
      const gradient = context.createRadialGradient(p.x, p.y, 0, p.x, p.y, radius);
      gradient.addColorStop(0, `rgba(${p.color},${opacity})`);
      gradient.addColorStop(0.45, `rgba(${p.color},${opacity * 0.65})`);
      gradient.addColorStop(1, `rgba(${p.color},0)`);
      context.fillStyle = gradient;
      context.beginPath();
      context.arc(p.x, p.y, radius, 0, Math.PI * 2);
      context.fill();
    }
    frame = particles.length ? requestAnimationFrame(draw) : 0;
  }
  function burst(x, y) {
    if (reducedMotion.matches || document.hidden) return;
    // Point inward near the top edge so the plume remains visible.
    const direction = y < 150 ? 1 : -1;
    for (let i = 0; i < 36; i++) {
      particles.push({ x: x + (Math.random() - 0.5) * 5, y,
        vx: (Math.random() - 0.5) * 38,
        vy: direction * (190 + Math.random() * 130),
        radius: 8 + Math.random() * 10,
        age: -(i / 36) * 0.3,
        life: 0.85 + Math.random() * 0.4,
        phase: Math.random() * Math.PI * 2,
        color: i % 6 === 0 ? '75,200,192' : '185,195,202' });
    }
    particles = particles.slice(-180);
    if (!frame) { previous = performance.now(); frame = requestAnimationFrame(draw); }
  }
  document.addEventListener('pointerdown', event => {
    if (event.isPrimary && event.button === 0) burst(event.clientX, event.clientY);
  }, { capture: true, passive: true });
  document.addEventListener('click', event => {
    if (event.detail !== 0 || !(event.target instanceof Element)) return;
    const bounds = event.target.getBoundingClientRect();
    burst(bounds.left + bounds.width / 2, bounds.top + bounds.height / 2);
  }, { capture: true, passive: true });
  window.addEventListener('resize', resize, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    cancelAnimationFrame(frame);
    frame = 0;
    particles = [];
    context.clearRect(0, 0, window.innerWidth, window.innerHeight);
  });
  resize();
})();
